<script setup lang="ts">
import { getTopics } from '~/api/topics';
import TopicCard from '~/components/cards/TopicCard.vue';

const { data: topicCards } = await useAsyncData(() => getTopics());
</script>

<template>
  <div class="topics">
    <div class="container">
      <h1 class="topics__header">Темы проектов</h1>
      <div class="topics__content">
        <topic-card
          v-for="(item, idx) in topicCards"
          :key="idx"
          :topic="item"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.topics {
  margin-top: 100px;
  margin-bottom: 64px;
  display: flex;
  align-items: start;

  &__header {
    font-size: 28px;
    font-weight: 600;
    line-height: 32px;
    text-align: start;
    margin-bottom: 32px;

    @include media-breakpoint-down(md) {
      text-align: center;
    }
  }

  &__content {
    display: grid;
    padding: 0 20px;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    @include media-breakpoint-down(xl) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-down(md) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>
